import React, { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
 
 
import Layout from './Layout';
 
 

const NOTFOUND = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [role, setRole] = useState('');
  const [token, setToken] = useState('');
  const [confirmStatusOpen, setConfirmStatusOpen] = useState('');
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState('');
  const Navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [rowNumber, setRowNumber] = useState([]);
  const [idStatus, setIdStatus] = useState('');
  const [roleList, setRoleList] = useState('');
  const [selectedRoles, setSelectedRoles] = useState('');
  const [message, setmessage] = useState('');
  const [tipe, settipe] = useState('');
//show table project
   


  return (
    <>
  <Layout message={message} setmessage={setmessage} tipe={tipe}>
  <div className='pd'><b>404</b> 
 
  </div>
 
  <div className="pd">
    <div style={{marginBottom:15}}>  
    </div>
        Page is not available
    </div>

     
 
      </Layout>
    </>
  );
};

export default NOTFOUND;